/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorBoardMember from './tumor-board-member';
import TumorBoardMemberDetail from './tumor-board-member-detail';
import TumorBoardMemberUpdate from './tumor-board-member-update';
import TumorBoardMemberDeleteDialog from './tumor-board-member-delete-dialog';

const TumorBoardMemberRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorBoardMember />} />
    <Route path="new" element={<TumorBoardMemberUpdate />} />
    <Route path=":id">
      <Route index element={<TumorBoardMemberDetail />} />
      <Route path="edit" element={<TumorBoardMemberUpdate />} />
      <Route path="delete" element={<TumorBoardMemberDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorBoardMemberRoutes;
